var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal", class: _vm.modalClass }, [
    _c("div", { staticClass: "modal-background" }),
    _c("div", { staticClass: "modal-card" }, [
      _vm.title
        ? _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title is-unselectable" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c(
              "button",
              {
                staticClass: "button delete",
                attrs: { "aria-label": "close" },
                on: { click: _vm.close },
              },
              [_c("x-icon")],
              1
            ),
          ])
        : _vm._e(),
      _c("section", { staticClass: "modal-card-body" }, [_vm._t("default")], 2),
    ]),
    !_vm.title
      ? _c("button", {
          staticClass: "modal-close is-large",
          attrs: { "aria-label": "close" },
          on: { click: _vm.close },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }